import { Practice } from 'src/pages/accueil/model/types';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useMutatePractice = () => {
  const httpClient = useHttpClient();

  const createPractice = async (data: Practice) => {
    return await httpClient.current?.post(`/api/practices`, data);
  };

  const updatePracticeById = async (id: number, data: Practice) => {
    return await httpClient.current?.put(`/api/practices/${id}`, data);
  };

  return { createPractice, updatePracticeById };
};
